var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout"},[_c('nav-bar'),_c('main',{staticClass:"layout-main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }